import dayjs from "dayjs";

export const isDateExpired = (expiresAt: string): boolean => {
  const now = dayjs().unix();
  return +expiresAt > now ? false : true;
};
